import { render, staticRenderFns } from "./DossierPestControl.vue?vue&type=template&id=c2163240&scoped=true&"
import script from "./DossierPestControl.vue?vue&type=script&lang=js&"
export * from "./DossierPestControl.vue?vue&type=script&lang=js&"
import style0 from "./DossierPestControl.vue?vue&type=style&index=0&id=c2163240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2163240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
